var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.643,
    height: 13.329,
    viewBox: "0 0 17.643 13.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Map",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_201",
    d: "M10.029,29.9l3.741,1.684a.691.691,0,0,0,.976-.63V20.694a.689.689,0,0,0-.408-.63L10.6,18.379a.691.691,0,0,0-.976.63V29.268a.691.691,0,0,0,.408.633Z",
    transform: "translate(-9.621 -18.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_202",
    d: "M39.4,31.591l3.741-1.685a.692.692,0,0,0,.408-.631V19.019a.691.691,0,0,0-.976-.631L38.83,20.071a.689.689,0,0,0-.408.63V30.96a.691.691,0,0,0,.976.631Z",
    transform: "translate(-32.162 -18.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_203",
    d: "M67.626,29.9l3.741,1.684a.691.691,0,0,0,.976-.63V20.694a.689.689,0,0,0-.408-.63L68.2,18.379a.692.692,0,0,0-.976.63V29.268a.692.692,0,0,0,.407.633Z",
    transform: "translate(-54.699 -18.318)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/icon-map.5162fa4d23930f974720213c98585b6f.svg";
export { ForwardRef as ReactComponent };